<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part">
<h2><span class="h2-inner">PART ONE</span></h2>
<h3><span class="h3-inner">upforit</span></h3>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?7fec99ed